export const helpers = {

  navTo (path, anchor) {

  },

  lazyImageLoad (delay, path, callback) {
    let image = document.createElement('img')
    setTimeout(function () {
      image.src = path
      callback(image.src)
    }, delay)
  }

}



// WEBPACK FOOTER //
// ./src/helpers/index.js